import { DownloadOutlined } from '@ant-design/icons';
import { getGetFrontRichiesteIdModuliIdSezioniIdFileCodiceQueryOptions } from '@framework/api-client/api/inquiries-compile/richieste-controller/richieste-controller.ts';
import { Button, message } from 'antd';
import { useHasDocumentsInlineViewer } from '../../../../ui/documents/useHasDocumentsInlineViewer.tsx';
import { useAuthDownload } from '../../../../utils/download/useAuthDownload.ts';

export interface IWidgetDownloadButtonProps {
  submissionId: string;
  submissionModuleId: string;
  sectionId: string;
  code: string;
  filename: string;
  /** ID del file */
  id: string;
  omissis?: boolean;
}

export function WidgetDownloadButton(props: IWidgetDownloadButtonProps) {
  const {
    sectionId,
    submissionId,
    submissionModuleId,
    code,
    filename,
    id,
    omissis,
  } = props;
  const hasInlineViewer = useHasDocumentsInlineViewer();

  const { download, isFetching } = useAuthDownload(
    getGetFrontRichiesteIdModuliIdSezioniIdFileCodiceQueryOptions,
    [
      submissionId,
      submissionModuleId,
      sectionId,
      code,
      { omissis, idAllegato: id },
    ],
    {
      filename,
      onError: e => {
        if (e.response?.status === 404) {
          message.error('File non trovato');
          return;
        }

        message.error(
          'Si è verificato un problema durante il download del file. Riprovare.',
        );
      },
      showInlineViewer: hasInlineViewer,
    },
  );

  return (
    <Button
      icon={<DownloadOutlined />}
      size="small"
      onClick={() => {
        download();
      }}
      loading={isFetching}
    />
  );
}
